export const SUBSCRIBED_AUTOMATIC_USER_STATES = 'SUBSCRIBED_AUTOMATIC_USER_STATES';
